module.exports = __webpack_public_path__ + "static/media/5.ca9628cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/baranovichi/5.jpg
// module id = 209
// module chunks = 0